import { CatalogProductsProps } from "store/modules/Catalog/types.store";
import { OrderProps } from "store/modules/Orders/types.store";

export function isGasDoPovoCatalogProduct(
  product?: Pick<CatalogProductsProps, "attributes"> | null,
): boolean {
  return !!product?.attributes?.gasDoPovo;
}

export function isGasDoPovoProductId(
  productId: string | undefined,
  catalogProducts?: CatalogProductsProps[] | null,
): boolean {
  if (!productId || !catalogProducts?.length) {
    return false;
  }
  const product = catalogProducts.find((item) => item.id === productId);
  return isGasDoPovoCatalogProduct(product);
}

function hasGasDoPovoFlag(
  attributes?: { gasDoPovo?: boolean } | null,
): boolean {
  return attributes?.gasDoPovo === true;
}

export function orderHasGasDoPovoItems(
  order?: Pick<OrderProps, "items"> | null,
): boolean {
  const { items } = order ?? {};
  if (!items?.length) {
    return false;
  }

  return items.some((item) => hasGasDoPovoFlag(item.attributes));
}
